module.exports = __webpack_public_path__ + "static/media/Hangman7.b2877427.png";